/**
 * Clés PassThrough du {@link BaseKPI} (même principe que les composants PrimeVue : classes injectables par bloc).
 */
export type BaseKpiPassThroughKey =
    | "root"
    | "title"
    | "valueRow"
    | "icon"
    | "value"
    | "subtitle"
    | "footer"

export type BaseKpiPassThrough = Partial<
    Record<BaseKpiPassThroughKey, string | string[]>
>

const KEYS: BaseKpiPassThroughKey[] = [
    "root",
    "title",
    "valueRow",
    "icon",
    "value",
    "subtitle",
    "footer",
]

function normalizeClass(input: string | string[] | undefined): string {
    if (!input) return ""
    if (Array.isArray(input)) return input.filter(Boolean).join(" ")
    return input.trim()
}

/**
 * Classes par défaut du KPI compact (liste de sources, etc.).
 */
export const BASE_KPI_PT_DEFAULTS: Record<BaseKpiPassThroughKey, string> = {
    root: "base-kpi flex flex-col items-center justify-center w-full min-h-[5rem] h-auto p-2 gap-2 overflow-hidden bg-white border border-gray-200 rounded-md transition-all duration-300 mx-auto",
    title: "base-kpi__title w-full text-xs text-primary-600 uppercase text-center",
    valueRow:
        "base-kpi__value-row flex items-center justify-center gap-2 min-w-0 w-full flex-1",
    icon: "base-kpi__data-icon shrink-0",
    value: "base-kpi__data-value text-base text-primary-800 text-center truncate min-w-0",
    subtitle:
        "base-kpi__subtitle w-full text-[0.65rem] leading-tight text-surface-500 text-center",
    footer: "base-kpi__footer w-full text-xs text-primary-600 text-center",
}

/**
 * Fusionne les classes par défaut avec le PassThrough utilisateur (concaténation, comme l’habillage PrimeVue).
 */
export function mergeBaseKpiPt(
    pt?: BaseKpiPassThrough
): Record<BaseKpiPassThroughKey, string> {
    const out = {} as Record<BaseKpiPassThroughKey, string>
    for (const key of KEYS) {
        const def = BASE_KPI_PT_DEFAULTS[key]
        const extra = normalizeClass(pt?.[key])
        out[key] = extra ? `${def} ${extra}`.trim() : def
    }
    return out
}
